export const ASSIGNED_ENTITIES = ['CallCenter', 'ClientAccount']
export const ACCOUNTABLE_ENTITIES = ['CallCenter', 'ClientAccount', 'None']

export class TicketClaim {
}

TicketClaim.findLastCallCenterActor = (ticketClaim) => {
    if (ticketClaim.ticketClaimChallengeAnswer) return ticketClaim.ticketClaimChallengeAnswer.answeredBy
    if (ticketClaim.ticketClaimAnswer) return ticketClaim.ticketClaimAnswer.answeredBy
    if (ticketClaim.ticketClaimQualification) return ticketClaim.ticketClaimQualification.qualifiedBy
    return null
}

TicketClaim.findLastClientActor = (ticketClaim) => {
    if (ticketClaim.ticketClaimChallenge) return ticketClaim.ticketClaimChallenge.challengedBy
    return ticketClaim.openedBy
}

TicketClaim.findLastCallCenterAction = (ticketClaim) => {
    const state = ticketClaim.state

    switch(state) {
        case 'ChallengeAnswered': return state
        case 'Challenged': return 'Answered'
        case 'Answered': return state
        case 'Qualified': return state
        default: return null
    }
}

TicketClaim.findLastClientAction = (ticketClaim) => {
    const state = ticketClaim.state

    switch(state) {
        case 'ChallengeAnswered': return 'Challenged'
        case 'Challenged': return state
        case 'Answered': return 'Opened'
        case 'Qualified': return 'Opened'
        case 'Opened': return state
        default: return null
    }
}

TicketClaim.findPriority = (ticketClaim) => {
    if (ticketClaim.urgencyLevel) return ticketClaim.urgencyLevel
    if (ticketClaim.ticketClaimQualification) return ticketClaim.ticketClaimQualification.treatmentPriority
    return null
}

export class OpenTicketClaimCmd {
}

OpenTicketClaimCmd.schema = {
    oneOf: [{
        type: 'object',
        properties: {
            urgencyLevelUid: {type: ['string', 'null']},
            description: {type: 'string'},
            commandType: {
                type: 'string',
                enum: ['OpenTicketClaim']
            }
        },
        required: ['description', 'commandType']
    }, {
        type: 'object',
        properties: {
            ticketReference: {type: 'string'},
            externalClientName: {type: ['string', 'null']},
            externalPatrimonyReference: {type: ['string', 'null']},
            externalCallDate: {type: 'date'},
            agencyUid: {type: 'string'},
            urgencyLevelUid: {type: ['string', 'null']},
            description: {type: 'string'},
            commandType: {
                type: 'string',
                enum: ['OpenTicketClaimOnExternalTicket']
            }
        },
        required: ['ticketReference', 'externalCallDate', 'agencyUid', 'description', 'commandType']
    }]
}

OpenTicketClaimCmd.selectSchema = (cmd) => {
    const commandType = cmd && cmd.commandType || 'OpenTicketClaimOnExternalTicket'

    return OpenTicketClaimCmd.schema.oneOf.find((schema) => {
        return schema.properties.commandType.enum.indexOf(commandType) >= 0
    })
}

export class QualifyTicketClaimCmd {
}

QualifyTicketClaimCmd.schema = {
    type: 'object',
    properties: {
    	ticketClaimCategoryUid: {type: 'string'},
    	treatmentPriorityUid: {type: ['string', 'null']},
        comment: {type: 'string'}
    },
    required: ['ticketClaimCategoryUid', 'comment']
}

export class AnswerTicketClaimCmd {
}

AnswerTicketClaimCmd.schema = {
    type: 'object',
    properties: {
        failureCauseUid: {type: 'string'},
        postAnalysisUid: {type: 'string'},
        severityUid: {type: 'string'},
        assignedEntities: {
            type: 'array',
            minItems: 1
        },
        accountableEntities: {
            type: 'array',
            minItems: 1
        },
        comment: {type: 'string'}
    },
    required: ['failureCauseUid', 'postAnalysisUid', 'severityUid', 'assignedEntities', 'accountableEntities', 'comment']
}

export class ChallengeTicketClaimCmd {
}

ChallengeTicketClaimCmd.schema = {
    type: 'object',
    properties: {
        comment: {type: 'string'}
    },
    required: ['comment']
}

export class AnswerChallengeTicketClaimCmd {
}

AnswerChallengeTicketClaimCmd.schema = {
    type: 'object',
    properties: {
        comment: {type: 'string'}
    },
    required: ['comment']
}


// WEBPACK FOOTER //
// ./lib/claim/models.js